import ProductCategoryDelete from './ProductCategoryDelete'
export {ProductCategoryDelete}
export default ProductCategoryDelete
